import { createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
    direction: 'ltr',

    palette: {
        primary: {
            main: '#5675D3',
            lessMain: '#8ba3f1',
            light: '#5675d31f',
            lighter: '#bdccfb',
            evenLighter: '#d7dffb',
            dark: '#2f3f71',
            contrastText: '#fff',
        },
        secondary: {
            main: '#F54C87',
            light: '#fb94b8',
            lighter: '#ffd5e4',
            dark: '#f91c69',
            contrastText: '#fff',
        },
        textColor: {
            white: '#fff',
            gray: '#777',
            gray2: '#ddd',
            gray3: '#eee',
            gray4: '#f2f4f4',
            gray5: '#0000008a',
            gray6: '#aaaaaa',
            gray7: '#bbbbbb',
            gray8: '#7d7d7d',
            gray9: "#ccc",
            green: '#19b821',
            blue: '#2757ca',
            blue2: '#32bdea',
            green2: '#1CBA34',
            lessTextColor: '#848484',
            primeTextColor: '#4F4F4F',
        },
        success: {
            main: '#00ff00',
        },
        info: {
            main: '#30bcec',
        },
        warning: {
            main: '#fdb31b'
        },
        danger: {
            main: '#ff0000',
        }
    },

    typography: {
        useNextVariants: true,
    },

    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 960,
            lg: 1280,
            xl: 1920,
            tablet: 640,
            laptop: 1024,
            desktop: 1280,
        },
    },
})

export default theme;
